<template>
  <VMapContext :apiKey="apiKey">
    <VMapFullScreenContent :mapId="mapId" :options="options" :endpointBusiness="endpointBusiness" :endpointEds="endpointEds">
    </VMapFullScreenContent>
  </VMapContext>
</template>

<script>
import VMapContext from "./VMapContext.vue"
import VMapFullScreenContent from "./VMapFullScreenContent.vue"
export default {
  name: "VMapFullScreen",
  props: {
    options: {
      type: Array,
      default: () => ([
        {
          "text": "Estaciones de servicio",
          "value": "eds",
          "icon": "icon-terpel"
        },
        {
          "text": "Gas Natural Vehícular",
          "value": "eds_price_4",
          "icon": "icon-gazel"
        },
        {
          "text": "Lubricantes",
          "value": "eds_services_SP-0012",
          "icon": "icon-terpel"
        },
        {
          "text": "Altoque",
          "value": "eds_services_SP-0007",
          "icon": "icon-altoque"
        },
        {
          "text": "Masterlub",
          "value": "business_type_Masterlub",
          "icon": "icon-masterlub"
        },
        {
          "text": "Voltex",
          "value": "business_type_Voltex",
          "icon": "icon-voltex"
        }
      ])
    },
    endpointEds: {
      type: String,
      require: true
    },
    endpointBusiness: {
      type: String,
      require: true
    },
    apiKey: {
      type: String,
      require: true
    },
    mapId: {
      type: String,
      require: true
    }
  },
  components: {
    VMapContext,
    VMapFullScreenContent
  },
}
</script>